import React, { useEffect, useCallback, useState, useRef } from "react";
import {
  StyleSheet,
  View,
  Text,
  Image,
  Linking,
  Alert,
} from "react-native-web";
import { useTranslation } from "react-i18next";
import Router, { useRouter } from "next/router";
import { MediaDao, AlbumDao } from "../../DAO";
import { CTabSelector } from "../../components/atoms";
import { MediaGrid } from "../../components/molecules";
import { Constants } from "../../config";
import Link from "next/link";
import { generateURLSlug } from "../../../helpers";
import Head from "next/head";
import Script from "next/script";
import MediaModal from "../profile/modals/MediaModal";

const MediaListContainer = (props) => {
  const { profileId, item, category, subTabType, isMobileVersion } = props;
  const navigation = useRouter();
  const mediaModalRef = useRef(null);
  // const isFocus = useIsFocused();
  const isFocus = true;
  const [selectedTabIndex, setSelectedTabIndex] = useState(
    subTabType == "albums" ? 1 : 0
  );
  const [totalMediaCount, setTotalMediaCount] = useState("");
  const [totalAlbumCount, setTotalAlbumCount] = useState("");
  const [medias, setMedias] = useState([]);
  const [albums, setAlbums] = useState([]);
  const [pageIndex, setPageIndex] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [mediaModalSelected, setMediaModalSelected] = useState({});
  const { t } = useTranslation();

  const menuItems = [
    {
      title:
        category !== Constants.categoryType.CATEGORY_ARTIST
          ? `${t("key_media_mix")}`
          : `${t("key_media_all")} ${totalMediaCount}`,
      // ? `${t("key_media_mix")} ${totalMediaCount}`
      // : `${t("key_media_all")} ${totalMediaCount}`,
    },
    {
      title: `${t("key_media_albums")}`,
    },
  ];
  useEffect(() => {
    if (props.tabType == Constants.profileTabType.TAB_MEDIA) {
      loadData();
    }
  }, [isFocus, props.tabType]);
  const onRefresh = () => {
    onLoadMedias();
  };
  const onLoadMore = () => {
    if (!isLoading) {
      onLoadMedias(pageIndex + 1);
    }
  };
  const onLoadMedias = (_pageIndex, pageSize = 20) => {
    if (!profileId) return;
    setIsLoading(true);
    const params = {
      pageIndex: _pageIndex || 1,
      pageSize: pageSize,
      albumId: 1,
    };
    if (profileId) {
      params.profileId = profileId;
    }
    MediaDao.find(params)
      .then((result) => {
        let _medias = [];
        if (params.pageIndex == 1) {
          _medias = result.data;
        } else {
          _medias = [...medias, ...result.data];
        }

        setMedias(_medias);
        setTotalMediaCount(result.totalCount);
        setPageIndex(params.pageIndex);
        setIsLoading(false);
      })
      .catch((ex) => {
        console.error("ex", ex);
        setIsLoading(false);
      });
  };
  const loadData = () => {
    const params = {};
    if (profileId) {
      params.profileId = profileId;
    }
    onLoadMedias();
    AlbumDao.find(params).then((result) => {
      setAlbums(result.data.filter((x) => x.id == Constants.albumType.MIX));
      setTotalAlbumCount(result.data.length);
    });
  };
  const onSelectTab = (index) => {
    setSelectedTabIndex(index);
    navigation.replace({
      pathname: generateURLSlug(
        item.id,
        item.title || item.displayName || item.nickname,
        item.startDate,
        category,
        "about"
      ),
      hash: "media",
      query: {
        subTabType: index == 1 ? "albums" : "all",
      },
    });
  };
  const onAlbumItemAction = (type, item) => {
    navigation.push({
      pathname: "/album/details",
      query: {
        profileId: profileId,
        albumId: item.id,
      },
    });
  };
  const onOpenExternalLink = async (url) => {
    const win = window.open(url, "_blank");
    win.focus();
  };
  const onMediaItemPress = (type, item) => {
    if (item.isLink && item.mediaType == Constants.mediaType.MEDIA_TYPE_VIDEO) {
      onOpenExternalLink(item.video);
    } else {
      mediaModalRef?.current?.showModal();
      setMediaModalSelected(item);
      // const id = item.id;
      // const profileId = item.profileId;
      // const albumId = item.albumId;
      // navigation.push({
      //   pathname: "/media/details",
      //   query: {
      //     id: id,
      //     profileId: profileId,
      //     albumId: albumId,
      //   },
      // });
    }
  };

  const renderContent = () => {
    if (selectedTabIndex == 0) {
      return (
        <MediaGrid
          items={medias}
          style={{ marginTop: isMobileVersion ? 8 : 16, marginBottom: 0 }}
          onItemAction={onMediaItemPress}
          onRefresh={onRefresh}
          onLoadMore={onLoadMore}
          isMobileVersion={isMobileVersion}
        />
      );
    } else {
      return (
        <MediaGrid
          items={albums}
          isAlbum={true}
          style={{ marginTop: isMobileVersion ? 8 : 16 }}
          onItemAction={onAlbumItemAction}
          isMobileVersion={isMobileVersion}
        />
      );
    }
    return null;
  };
  if (!profileId) {
    return (
      <View style={[styles.container, props.style]}>
        <CTabSelector
          items={menuItems}
          selectedIndex={selectedTabIndex}
          tabItemType="colored-round-tab"
          onSelectTab={(item, index) => {
            onSelectTab(index);
          }}
          containerStyle={{
            marginTop: 0,
            marginHorizontal: 0,
            paddingHorizontal: isMobileVersion ? 16 : 0,
          }}
          isMobileVersion={isMobileVersion}
        />
      </View>
    );
  }

  return (
    <View style={[styles.container, props.style]}>
      <CTabSelector
        items={menuItems}
        selectedIndex={selectedTabIndex}
        tabItemType="colored-round-tab"
        onSelectTab={(item, index) => {
          onSelectTab(index);
        }}
        containerStyle={{
          marginTop: 18,
          marginHorizontal: 0,
          paddingHorizontal: isMobileVersion ? 16 : 0,
        }}
        isMobileVersion={isMobileVersion}
      />
      {renderContent()}

      <MediaModal
        ref={mediaModalRef}
        item={mediaModalSelected}
        isMobileVersion={isMobileVersion}
        onPrev={() => {
          const selectedItemIndex = medias
            .filter((i) => i.mediaType === "image")
            .findIndex((i) => i.id === mediaModalSelected?.id);
          const newIndex =
            selectedItemIndex - 1 < 0
              ? medias.filter((i) => i.mediaType === "image").length - 1
              : selectedItemIndex - 1;
          setMediaModalSelected(
            medias.filter((i) => i.mediaType === "image")[newIndex]
          );
        }}
        onNext={() => {
          const selectedItemIndex = medias
            .filter((i) => i.mediaType === "image")
            .findIndex((i) => i.id === mediaModalSelected?.id);
          const newIndex =
            selectedItemIndex + 1 >
            medias.filter((i) => i.mediaType === "image").length - 1
              ? 0
              : selectedItemIndex + 1;
          setMediaModalSelected(
            medias.filter((i) => i.mediaType === "image")[newIndex]
          );
        }}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    alignSelf: "stretch",
    paddingBottom: 16,
  },
  profileTagContainer: {
    marginTop: 8,
  },
  rowContainer: {
    flexDirection: "row",
    alignItems: "center",
  },
});

export default MediaListContainer;
